import Vue from "vue"
import App from "./App.vue"
import Vuetify from 'vuetify'
import VueShortkey from 'vue-shortkey'
import VueFullPage from 'vue-fullpage.js'

import store from "./store"
import router from "./router"
import { i18n } from "./lang"

import "./registerServiceWorker"
import 'vuetify/dist/vuetify.min.css'
import 'fullpage.js/vendors/scrolloverflow' // Optional. When using scrollOverflow:true
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.use(Vuetify)
Vue.use(VueFullPage)
Vue.use(VueShortkey)

Vue.config.productionTip = false;

/* global appConfig */
Vue.$core = Vue.prototype.$core = appConfig

Vue.$licenceKey = Vue.prototype.$licenceKey = '1C9BFF52-E1444DA1-8C916000-566608F0'

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app")





// console.log ('%c                                                               \n  ██████╗  █████╗ ███╗   ██╗ ██████╗  █████╗ ███████╗ █████╗   \n  ██╔══██╗██╔══██╗████╗  ██║██╔════╝ ██╔══██╗██╔════╝██╔══██╗  \n  ██████╔╝███████║██╔██╗ ██║██║  ███╗███████║█████╗  ███████║  \n  ██╔═══╝ ██╔══██║██║╚██╗██║██║   ██║██╔══██║██╔══╝  ██╔══██║  \n  ██║     ██║  ██║██║ ╚████║╚██████╔╝██║  ██║███████╗██║  ██║  \n  ╚═╝     ╚═╝  ╚═╝╚═╝  ╚═══╝ ╚═════╝ ╚═╝  ╚═╝╚══════╝╚═╝  ╚═╝  \n  -----------------------© pangaea.co.uk---------------------  \n                 I see what you are trying to do;)             \n                                                               ', 'background: #D13239; color: white');

console.log(`%c
  .______      ___      .__   __.   ______       ___       _______       ___
  |   _  \\    /   \\     |  \\ |  |  /  ____|     /   \\     |   ____|     /   \\
  |  |_)  |  /  ^  \\    |   \\|  | |  |  __     /  ^  \\    |  |__       /  ^  \\
  |   ___/  /  /_\\  \\   |  . \\  | |  | |_ |   /  /_\\  \\   |   __|     /  /_\\  \\
  |  |     /  _____  \\  |  |\\   | |  |__| |  /  _____  \\  |  |____   /  _____  \\
  | _|    /__/     \\__\\ |__| \\__|  \\______| /__/     \\__\\ |_______| /__/     \\__\\
  -------------------------------© pangaea.co.uk---------------------------------
      \\,,/(^_^)\,,/        Found something interesting?         \\,,/(^_^)\\,,/
                                                                                   `, 'background: #D13239; color: white');
